import type { DrawContext, DrawData } from '@antv/g6'
import { BaseTransform } from '@antv/g6'

export class HideFreeNode extends BaseTransform {
  public beforeDraw(input: DrawData, context: DrawContext): DrawData {
    const { model } = this.context
    const { add, update, remove } = input

    add.nodes.forEach((nodeData, nodeId) => {
      // 获取节点的相关连线
      const edges = model.getRelatedEdgesData(nodeId)
      // 没有任何连线的的节点则从add里面移除，添加到remove里面
      if (!edges.length) {
        add.nodes.delete(nodeId)
        remove.nodes.set(nodeId, nodeData)
      }
    })

    return input
  }
}
